// extracted by mini-css-extract-plugin
module.exports = {"background":"ModalWrapper_background__1als6","wrapper":"ModalWrapper_wrapper__2bZJI"};